import { render, staticRenderFns } from "./CancellationResultCard.vue?vue&type=template&id=a9fe5260&"
import script from "./CancellationResultCard.vue?vue&type=script&lang=js&"
export * from "./CancellationResultCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports